if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('.product-form__submit-text');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const bundleBuilder = this.closest('product-bundle-builder');
        if (bundleBuilder) {
          const validationError = bundleBuilder.getBundleValidationError();
          if (validationError) {
            this.handleErrorMessage(validationError);
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (bundleBuilder) {
          const variantIds = bundleBuilder.getBundleVariantIds();

          const newFormData = new FormData();
          variantIds.forEach((variantId, index) => {
            newFormData.append(`items[${index}][id]`, variantId);
            newFormData.append(`items[${index}][quantity]`, 1);
          });

          for (const pair of formData.entries()) {
            if (pair[0] === 'sections' || pair[0] === 'sections_url') {
              newFormData.append(pair[0], pair[1]);
            }
          }

          newFormData.get = function (name) {
            if (name === 'id') return variantIds[0];
            if (name === 'quantity') return 1;
            return FormData.prototype.get.call(this, name);
          };

          formData = newFormData;
        } else {
          const productInfo = this.closest('product-info');
          const selectedUpsells = productInfo
            ? productInfo.querySelectorAll('.upsell-toggle-btn.select')
            : [];

          if (selectedUpsells.length > 0) {
            const mainVariantId = formData.get('id');
            const mainQty = formData.get('quantity') || 1;

            const newFormData = new FormData();
            newFormData.append('items[0][id]', mainVariantId);
            newFormData.append('items[0][quantity]', mainQty);

            let itemIndex = 1;
            selectedUpsells.forEach((upsellToggle) => {
              const upsellVariantId = upsellToggle.dataset.variantId;
              if (!upsellVariantId) return;

              newFormData.append(`items[${itemIndex}][id]`, upsellVariantId);
              newFormData.append(`items[${itemIndex}][quantity]`, 1);
              newFormData.append(`items[${itemIndex}][properties][_parent_id]`, mainVariantId);
              itemIndex += 1;
            });

            for (const pair of formData.entries()) {
              if (pair[0] === 'sections' || pair[0] === 'sections_url') {
                newFormData.append(pair[0], pair[1]);
              }
            }

            newFormData.get = function (name) {
              if (name === 'id') return mainVariantId;
              if (name === 'quantity') return mainQty;
              return FormData.prototype.get.call(this, name);
            };

            formData = newFormData;
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const errorMessage = this.formatCartAddError(response);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(errorMessage);
              this.error = true;

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('Could not add to cart. Please check your connection and try again.');
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      formatCartAddError(response) {
        if (!response) return 'Could not add to cart. Please try again.';

        const parts = [];

        if (response.description) parts.push(response.description);
        if (response.message && response.message !== response.description) parts.push(response.message);

        if (response.errors) {
          if (typeof response.errors === 'string') {
            parts.push(response.errors);
          } else {
            Object.entries(response.errors).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                value.forEach((entry) => parts.push(`${key}: ${entry}`));
              } else if (value) {
                parts.push(`${key}: ${value}`);
              }
            });
          }
        }

        return parts.filter(Boolean).join(' ') || 'Could not add to cart. Please try again.';
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
